// Hooks/useGET/useGetTimeOffsBySearch.js
import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

// stable reference, reused instead of a new [] literal each render, so
// components depending on searchResults don't see a "changed" value on
// every render when there's nothing to show
const EMPTY_RESULTS = [];

export default function useGetTimeOffsBySearch(filters) {
  const params = new URLSearchParams();
  if (filters?.from) params.append("from", filters.from.toISOString());
  if (filters?.to) params.append("to", filters.to.toISOString());
  if (filters?.employeeName)
    params.append("employeeName", filters.employeeName);
  if (filters?.supervisorName)
    params.append("supervisorName", filters.supervisorName);
  if (filters?.workCenterName)
    params.append("workCenterName", filters.workCenterName);

  const key = filters
    ? `${apiBaseURL}/api/user/timeoffs/search?${params.toString()}`
    : null;

  const { data, error, mutate } = useSWR(key, {
    revalidateOnFocus: false,
    dedupingInterval: 300000,
  });

  // the API returns the plain string "No Records Found" instead of an
  // empty array when nothing matches, normalize anything that isn't
  // actually an array to the same stable empty reference
  const results = Array.isArray(data?.data) ? data.data : EMPTY_RESULTS;

  return { searchResults: results, error, mutate };
}
